import { React, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

const WaittingTopView = forwardRef((props, ref) => {
  const { isWaitting, settingWaittingView, waittingCnt, ignoreCnt } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const TopLevelRef = useRef();
  const RejectDisplayRef = useRef();
  const WaitterDisplayRef = useRef();
  
  useImperativeHandle(ref, () => ({
    setZindex: (val) => {
      TopLevelRef.current.style.zIndex = val;
    }
  }));

  // 마우스 호버링 이벤트
  function onMouseOver(className) {
    if (className === 'Reject') {
      RejectDisplayRef.current.style.color = theme.subBackground;
      RejectDisplayRef.current.style.backgroundColor = theme.line;
    }
    else if (className === 'Wait') {
      WaitterDisplayRef.current.style.color = theme.subBackground;
      WaitterDisplayRef.current.style.backgroundColor = theme.primary;
    }
  }

  // 마우스 호버링 이벤트
  function onMouseLeave(className) {
    if (className === 'Reject') {
      RejectDisplayRef.current.style.color = theme.subBackground;
      RejectDisplayRef.current.style.backgroundColor = theme.subText;
    }
    else if (className === 'Wait') {
      WaitterDisplayRef.current.style.color = theme.subBackground;
      WaitterDisplayRef.current.style.backgroundColor = theme.subKey;
    }
  }

  function onClick(className) {
    settingWaittingView(className);
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      {
        isWaitting ?
          <TitleWrapper>
            <Title>{t('waiting.paymentRequests')}</Title>
            <Explanation>{t('waiting.approvalDesc')}</Explanation>
          </TitleWrapper>
          :
          <TitleWrapper>
            <Title>{t('waiting.DeclineTitle')}</Title>
            <Explanation>{t('waiting.DeclineDesc')}</Explanation>
          </TitleWrapper>
      }
      <TotalButtonWrapper>
        <ButtonWrapper className='Reject' onClick={() => onClick('Reject')} onMouseOver={() => onMouseOver('Reject')} onMouseLeave={() => onMouseLeave('Reject')}>
          <CountDisplay ref={RejectDisplayRef} backgroundColor={theme.subText} color={theme.subBackground}>{ignoreCnt}</CountDisplay>
          <RejectButton>
            <ButtonText>{t('waiting.DeclinedMemberBtn')}</ButtonText>
          </RejectButton>
        </ButtonWrapper>
        <ButtonWrapper className='Wait' onClick={() => onClick('Wait')} onMouseOver={() => onMouseOver('Wait')} onMouseLeave={() => onMouseLeave('Wait')}>
          <CountDisplay ref={WaitterDisplayRef} backgroundColor={theme.subKey} color={theme.subBackground}>{waittingCnt}</CountDisplay>
          <WaitterButton>
            <ButtonText>{t('waiting.waitingMemberBtn')}</ButtonText>
          </WaitterButton>
        </ButtonWrapper>
      </TotalButtonWrapper>
    </TopLevelWrapper>
  )
})

export default WaittingTopView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  z-index: 1;

  width: 1035px;
  height: 75px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const TotalButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 22px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const CountDisplay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  z-index: 3;

  margin-top: -5px;
  margin-left: -8px;

  font-family: NotoSansKR-Bold;
  font-size: 12px;

  padding-bottom: 2px;

  color: ${props => props.color};

  border-radius: 28px;
  background-color: ${props => props.backgroundColor};
  
  transition: all 0.3s ease-in-out;
  
  &:hover {
    cursor: default;
  }
`;

const RejectButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 20px;

  height: 40px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 15px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.line};
  }
`;

const WaitterButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 20px;

  height: 40px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 15px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.primary};
  }
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color:  ${props => props.theme.subText};

  margin: 0 0 0 0;
`;
